var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpinner = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.284 57.665A32.14 32.14 0 0 1 3.39 40.032a32.311 32.311 0 0 1 3.065-19.547A31.861 31.861 0 0 1 20.307 6.49a31.414 31.414 0 0 1 19.349-3.096m18.06 8.94a32.14 32.14 0 0 1 8.894 17.634 32.311 32.311 0 0 1-3.065 19.548A31.86 31.86 0 0 1 49.693 63.51a31.413 31.413 0 0 1-19.348 3.096",
    stroke: "currentColor",
    strokeWidth: 6
  })));
};
export { SvgSpinner as ReactComponent };